import useAmericanIssuer from "components/company/v3/context/hooks/useAmericanIssuer";
import { EventsCalendarList, EventsCalendar } from "components/investorrelations/EventsCalendar";
import type { EventsCalendarState } from "components/investorrelations/EventsCalendarLocalState";
import RightSideFilters, { RightSideFiltersEnum } from "components/investorrelations/RightSideFilters";
import { Provider } from "jotai";
import { IIssuerType } from "types/graphqlTypes";

interface AmericanCalendarContentProps extends EventsCalendarState {
  tickerSymbol: string;
  isRenderPageDefault: boolean;
}

export default function AmericanCalendarContent({
  tickerSymbol,
  isRenderPageDefault,
  ...filterState
}: AmericanCalendarContentProps) {
  const issuer = useAmericanIssuer();

  return (
    <Provider>
      <EventsCalendar
        {...filterState}
        issuerType={issuer.isREIT ? IIssuerType.AmericanReit : IIssuerType.AmericanCompany}
        searchQuery={tickerSymbol}
        limit={isRenderPageDefault ? 5 : 20}
      >
        {({ error, loading, isLoadingMore, loadMoreEvents }) => {
          return (
            <>
              <div className="col-span-12 row-start-2 space-y-4 lg:col-span-8 lg:row-start-1">
                <EventsCalendarList
                  {...filterState}
                  searchQuery={tickerSymbol}
                  loading={loading}
                  isLoadingMore={isLoadingMore}
                  loadMoreEvents={loadMoreEvents}
                  error={error}
                />
              </div>

              <div className="col-span-12 space-y-4 lg:col-span-4">
                <RightSideFilters
                  {...filterState}
                  issuerType={issuer.isREIT ? IIssuerType.AmericanReit : IIssuerType.AmericanCompany}
                  className="grid-cols-2 sm:relative sm:top-0"
                  enableFilters={[
                    RightSideFiltersEnum.EventType,
                    RightSideFiltersEnum.FilterRange,
                    RightSideFiltersEnum.MonthViewCalendar,
                  ]}
                />
              </div>
            </>
          );
        }}
      </EventsCalendar>
    </Provider>
  );
}
